<template>
  <div class="card-item transition-slow">
    <div class="info-content">
      <div class="info-item">
        <!-- <h2 class="login-title">Inicio de Sesión</h2> -->
        <h2 class="login-title">{{ $t('login.title') }}</h2>
        <form @submit.prevent="onSubmit">
          <TextInput
            id="email"
            v-model="email"
            :label="$t('login.email')"
            :type="'email'"
            :icon="'fa-envelope'"
            :error="email === '' && errorMessage != ''" />
          <TextInput
            id="password"
            v-model="password"
            :label="$t('login.password')"
            :type="'password'"
            :icon="'fa-lock'"
            :error="password === '' && errorMessage != ''" />
          <p
            class="error-mesagge transition-fast"
            :class="errorMessage !== '' ? 'show-error' : ''"
            v-html="errorMessage" />
          <!-- <button id="loginButton" class="button is-button-primary transition-fast is-rounded" type="submit">Ingresar</button> -->
          <button id="loginButton" class="button is-button-primary transition-fast is-rounded" type="submit">{{ $t('login.login') }}</button>
        </form>
        <!-- <router-link class="forgot-password" :to="{name: 'reset-password'}">
          Olvidé mi contraseña
        </router-link> -->
        <router-link v-if="$i18n.locale==='cl'" class="forgot-password" :to="{name: 'reset-password'}">
          {{ $t('login.forgetPassword') }}
        </router-link>
      </div>
      <div class="spinner-content" :class="isLoading ? 'is-loading' : ''">
        <div class="spinner">
          <div class="double-bounce1" />
          <div class="double-bounce2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authenticationService } from '@/application/services/api-clients/login-service';
import TextInput from '@/ui/components/input/TextInput.vue';

export default {
  name: 'Login',
  components: { TextInput },
  data() {
    return {
      email: '',
      password: '',
      returnUrl: '',
      errorMessage: '',
      isLoading: false
    };
  },
  /* mounted() {
    this.$i18n.locale = 'br';
  }, */
  created() {
    if (this.$store.state.currentUser) {
      const { user } = this.$store.state.currentUser;
      if (user.checkIn && !user.checkIn.is && user.required) {
        this.$router.push({ name: 'check-in' });
      } else {
        const { pathname } = window.location;
        // Cuando usuario esta logueado y requiere entrtar al mismo país se le deja pasar al main.
        if (user && pathname.includes(user.country)) {
          this.$router.push({ name: 'main' });
        } else {
          this.$store.state.currentUser = null; // evita el salto de sesion entre paises
        }
      }
    }
    this.returnUrl = this.$route.query.returnUrl || 'main';
  },
  methods: {
    sanitizeMail: mail => `${mail}`.toLowerCase().trim(),
    async sendLoginAction({ user }) {
      try {
        if (!user) {
          return;
        }
        const action = {
          country: this.$i18n.locale,
          view: this.$route.name,
          user_id: user._id,
          user_rol: user.rol,
          executed_at: new Date(),
          action: 'login'
        };
        if (user.rol === 'INVESTOR' && user.investorsIds) {
          action.metadata = { investorsIds: user.investorsIds };
        }
        // this.$socket.emit('action', action);
      } catch (error) {
        this.$log.warn('Error al enviar action login', error);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      this.errorMessage = '';
      /* this.errorMessage += this.email === '' ? 'El email no puede ser vacío.<br>' : ''; */
      /* this.errorMessage += this.password === '' ? 'La contraseña no puede ser vacía.' : ''; */
      this.errorMessage += this.email === '' ? `${this.$t('login.emptyEmail')} <br>` : '';
      this.errorMessage += this.password === '' ? this.$t('login.emptyPassword') : '';
      if (this.errorMessage === '') {
        const sanitizedMail = this.sanitizeMail(this.email).trim();
        await authenticationService.login(sanitizedMail, this.password)
          .then(
            user => {
              this.isLoading = false;
              if (user) {
                this.sendLoginAction(user);
                this.$router.push({ name: this.returnUrl });
              }
            },
            () => {
              this.isLoading = false;
              this.$router.push({ name: 'not-available' });
            }
          );
      }
      this.isLoading = false;
    }
  }

};

</script>
<style lang="css" scoped>
  .card-item {
    overflow: hidden;
  }
  .info-content {
      width: 100%;
      float:left;
      text-align: center;
      padding: 10px;
      position: relative;
  }
  .info-content .info-item .login-title{
      margin-top: 10px;
      margin-bottom: 0px;
      font-size: 30px;
      color: #00CCD1;
  }
  .info-content .login-button {
      margin: 30px auto 10px;
      font-size: 15px;
      border: none;
      background-color:var(--secondary);
      width: 30%;
      padding: 12px;
      border-radius: 40px;
      font-family: var(--primary-font);
      cursor:pointer;
      color: #ffffff;
  }
  .info-content .login-button:hover {
      background-color: var(--secondary-dark);
  }
  .button{
      margin: 10px 0;
  }
  .spinner-content {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background-color: #ffffff78;
      display: none;
      opacity: 0;
  }
  .spinner-content.is-loading {
    display: block;
    opacity: 1;
  }

  .error-mesagge {
    color: red;
    font-size: 12px;
    max-height: 0;
    margin-top: 20px;
  }
  .error-mesagge.show-error {
    max-height: 500px;
  }
  .input-content {
    width: 60%;
    margin-top: 20px;
  }
  .forgot-password {
    color: var(--color-nickel) !important;
    font-size: 12px;
    text-decoration: underline;
  }
  @media (max-width: 1024px) {
  }

  @media (max-width: 768px) {
      .info-content .reset-password {
          font-size: 10px;
          width: 50%;
      }
      .info-content .error-password {
          font-size: 10px;
          width: 50%;
          }
  }
  @media (max-width: 640px) {
      .info-content .info-item .login-title{
          margin: 30px;
          font-size: 25px;
          }
      .info-content .mail-box {
          margin: 20px auto 20px auto;
          font-size: 11px;
          width: 70%;
      }
      .info-content .password-box {
          font-size: 11px;
          width: 70%;
          }
      .info-content .login-box {
          font-size: 12px;
          background-color:#E9007F;
          width: 40%;
          padding: 10px;
          }
      .info-content .reset-password {
          font-size: 7px;
          width: 50%;
      }
      .info-content .error-password {
          font-size: 7px;
          width: 50%;
          }
    .input-content{
      width: 90%;
    }
  }
  @media (max-width: 420px) {
      .info-content .info-item .login-title{
          margin: 20px;
          font-size: 25px;
          }
      .info-content .mail-box {
          margin: 20px auto 20px auto;
          font-size: 11px;
          width: 80%;
      }
      .info-content .password-box {
          margin: 20px auto 20px auto;
          font-size: 11px;
          width: 80%;
      }
  }

</style>
